import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import { measureInitialPageLoadTimingAsync } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools';
import { startJiraSpa } from './start-jira-spa.tsx';

setMark('JIRA_SPA_ENTRY_LOADED');

startJiraSpa(async () =>
	measureInitialPageLoadTimingAsync('jira-spa/setup/load-routes', async () => {
		const { default: getRoutes } = await import(
			/* webpackChunkName: "async-route-map" */ '@atlassian/jira-routes/src/ui/spa/async-routes.tsx'
		);
		return getRoutes;
	}),
);
